import AppHeader from '../AppHeader'

export default {
  name: 'ability-question-detail',
  created () {
    this.search()
  },
  data () {
    return {
      title: '',
      skillType: null,
      questions: [],
      canValidate: true
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      this.$store.dispatch('GET_ABILITY_QUESTION_DETAIL', { id: this.$route.params.id })
      .then(res => {
        this.title = res.title.title
        if (res.title.skillType === 1) {
          this.skillType = '個人スキル'
        } else if (res.title.skillType === 2) {
          this.skillType = '業務スキル'
        }
        if (res.question_details.length > 0) {
          this.questions = res.question_details
        }
      })
      .catch(err => console.log(err))
    },
    newLineContent: function (word) {
      return word ? word.replace(/\r?\n/g, '<br>') : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/ability-question-detail.js